export const EmailPattern =
  /^([-!#$%&'*+/=?^_`{}|~0-9A-Z]+(\.[-!#$%&'*+/=?^_`{}|~0-9A-Z]+)*|"(?:[!#-[\]-~]|\\[!-~])*")@((?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+(?:[A-Z0-9-]{2,63}(?<!-))|\[(?:\d{1,3}\.){3}\d{1,3}\])$/i;
export const LinkPattern =
  /^(https?:\/\/)([a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.(([a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.)?([a-zA-Z]{2,})$/;
export const LinkOfferPattern =
  /^(https?:\/\/)(?!-)([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/[^\s]*)?(\?([^\s=&]+=[^\s=&]*)([^\s=&]+=[^\s=&]*)*)?$/;
export const PostbackLinkPattern =
  // eslint-disable-next-line no-useless-escape
  /^(https?:\/\/)((([a-zA-Z][a-zA-Z0-9\-]*\.)+[a-zA-Z]{2,})|(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}))(:[0-9]+)?(\/[a-zA-Z0-9\-]*)*(\?([a-zA-Z0-9_\-{}]+\=[a-zA-Z0-9_\-{}%]*|\{[a-zA-Z0-9_\-]+\}))?(?:&[a-zA-Z0-9_\-{}]+\=[a-zA-Z0-9_\-{}%]*)*(\#[a-zA-Z0-9\-]+)?$/;
export const PromoLinkPattern =
  /^(https?:\/\/)[a-zA-Z0-9.-]+\/[a-zA-Z0-9_-]+\/\?((lang=[a-zA-Z]{2,})(&st=[a-zA-Z0-9]+)?(&s1=[a-zA-Z0-9]+)?(&s2=[a-zA-Z0-9]+)?(&s3=[a-zA-Z0-9]+)?(&s4=[a-zA-Z0-9]+)?(&s5=[a-zA-Z0-9]+)?(&pc=[a-zA-Z0-9]+)?(&form_phone=\+?[0-9]+)?(&form_email=[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})?)?$/;
export const WebsitePattern =
  /^(https?:\/\/)([a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.(([a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.)?([a-zA-Z]{2,})$/;

export const MinLength = 3;
export const MaxLength = 128;
export const ExtendedMaxLength = 255;
export const PostbackMaxLength = 255;
export const MaxKLength = 1024;
export const MinNumberLength = 0;
export const MaxNumberLength = 100;
export const passwordMinLength = 10;
export const financesAmountMinValue = 30;
export const amountMaxValue = 999999999.99;
export const lowerCasePattern = /[a-z]/;
export const upperCasePattern = /[A-Z]/;
export const numbersPattern = /\d/;
export const specialCharactersPattern = /[!@#$%^&_-]/;
// eslint-disable-next-line no-useless-escape
export const markSubjectPattern = /^[a-zA-Z0-9._\-():=+{}\/[\]|]{1,64}$/;
export const GoogleSheetsPattern = /^https:\/\/(www\.)?docs\.google\.com\/spreadsheets\//;
